import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandLinesListComponent } from './components/land-lines-list/land-lines-list.component';
import { LandLinesRoutingModule } from './landlines-routing.module';
import { SharedModule } from '../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { ConstsHelper } from '../../helpers/consts.helper';
import { landLineListReducer } from './store/reducers/land-lines-list.reducer';
import { landLineReducer } from './store/reducers/land-line.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LandLineListEffects } from './store/effects/land-line-list.effects';
import { ModalLandLinesListComponent } from './components/modal-land-lines-list/modal-land-lines-list.component';
import { LandLinesService } from './services/land-lines.service';
import { LandLineDetailsComponent } from './components/land-line-details/land-line-details.component';
import { LandLineManagementComponent } from './components/land-line-management/land-line-management.component';
import { landLineProceduresReducer } from './store/reducers/land-line-procedure.reducer';
import { LandLineProceduresEffects } from './store/effects/land-line-procedures.effects';
import { LandLineProcedureService } from './services/land-line-procedure.service';
import { landlineConsumptionReducer } from './store/reducers/land-line-consumption.reducer';
import { LandLineConsumptionEffects } from './store/effects/land-line-consumption.effects';
import { LandLineConsumptionComponent } from './components/land-line-consumption/land-line-consumption.component';
import { LandLineConsumptionDetailsComponent } from './components/land-line-consumption-details/land-line-consumption-details.component';

@NgModule({
  declarations: [LandLinesListComponent, ModalLandLinesListComponent, LandLineDetailsComponent, LandLineManagementComponent, LandLineConsumptionComponent, LandLineConsumptionDetailsComponent],
  imports: [
    CommonModule,
    LandLinesRoutingModule,
    SharedModule,
    StoreModule,
    StoreModule.forFeature(ConstsHelper.REDUCER_LAND_LINES_LIST, landLineListReducer),
    StoreModule.forFeature(ConstsHelper.REDUCER_LAND_LINE, landLineReducer),
    StoreModule.forFeature(ConstsHelper.REDUCER_LAND_LINE_PROCEDURES, landLineProceduresReducer),
    StoreModule.forFeature(ConstsHelper.REDUCER_LAND_LINE_CONSUMPTION, landlineConsumptionReducer),
    EffectsModule.forFeature(
      [
        LandLineListEffects,
        LandLineProceduresEffects,
        LandLineConsumptionEffects
      ]
    )
  ],
  exports: [
    ModalLandLinesListComponent
  ],
  providers: [
    LandLinesService,
    LandLineProcedureService,
  ]
})
export class LandlinesModule { }
